export const testAttributes = {
    PRIMARY_CTA_CONTAINER: 'primary-cta-container',
};

export const qlctabuttonlinkClass = 'ql-ctabutton-link';
